import  { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import './AlumniFeedback.css';
import axios from '../../api/axios';

const AlumniFeedback = () => {
  // WebSocket connection
  useEffect(() => {
    const timeout = setTimeout(() => {
      const socket = new WebSocket(`ws://${window.location.hostname}:5001/ws`);

      socket.onopen = () => {
        // console.log('✅ WebSocket connected');
        socket.send('Hello server');
      };

      // socket.onmessage = (event) => {
      //   console.log('📩 Message from server:', event.data);
      // };

      socket.onclose = () => {
        console.log('❌ WebSocket disconnected');
      };
    }, 200); // delay connection

    return () => clearTimeout(timeout);
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    alumniId: '',

    // Academic involvement
    academic: [],
    otherAcademic: '',

    // Administrative involvement
    administrative: [],
    otherAdministrative: '',

    // Finance/Development involvement
    finance: [],
    otherFinance: '',

    // Other feedback
    importantThings: '',
    suggestions: '',
    alumniList: '',
  });

  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState(''); // 'success' | 'error'
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle checkbox changes
  const handleCheckboxChange = (category, value) => {
    setFormData((prev) => {
      const updatedCategory = prev[category].includes(value)
        ? prev[category].filter((item) => item !== value)
        : [...prev[category], value];
      return { ...prev, [category]: updatedCategory };
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!user) {
    setStatusMessage('User not found. Please log in again.');
    setStatusType('error');
    return;
  }

  const payload = {
    ...formData,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    alumniId: user.idNo,
  };

  try {
    const response = await axios.post('/api/feedback/submit', payload);

    setStatusMessage(response.data.message || 'Feedback submitted successfully!');
    setStatusType('success');

    // Reset form
    setFormData({
      academic: [],
      otherAcademic: '',
      administrative: [],
      otherAdministrative: '',
      finance: [],
      otherFinance: '',
      importantThings: '',
      suggestions: '',
      alumniList: '',
    });
  } catch (error) {
    console.error(error);
    setStatusMessage(
      error.response?.data?.message || 'An error occurred. Please try again.'
    );
    setStatusType('error');
  }

  setTimeout(() => {
    setStatusMessage('');
    setStatusType('');
  }, 5000);
};


  return (
      <div className="alumnifeedback-content">
        <div className="alumnifeedback-card">
          <div className="alumnifeedback-card-header">
            <img
              src="/smulogo.png"
              alt="SMU Logo"
              className="alumnifeedback-form-logo"
            />
            <h1 className="alumnifeedback-title">Alumni Feedback Form</h1>
          </div>

          <form onSubmit={handleSubmit} className="alumnifeedback-form">
            <h2 className="alumnifeedback-section-title">
              Areas of Involvement
            </h2>
            <p className="alumnifeedback-section-description">
              As a graduate (an alumnus/alumna), in what area and in what ways
              would you like yourself to be involved in the affairs of your Alma
              Mater?
            </p>

            {/* Academic */}
            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-subsection-title">❖ Academic</h3>
              <div className="alumnifeedback-checkbox-group">
                {[
                  'Voluntary Consultancy Service',
                  'As a member of the pool of Resource Speaker in and out of the university',
                  'Curriculum Development/enrichment',
                  'Volunteer Researcher of the University',
                  'Volunteer Guest Lecture in the University',
                ].map((item) => (
                  <div key={item} className="alumnifeedback-checkbox-item">
                    <input
                      type="checkbox"
                      id={item.replace(/\s+/g, '-').toLowerCase()}
                      checked={formData.academic.includes(item)}
                      onChange={() => handleCheckboxChange('academic', item)}
                    />
                    <label htmlFor={item.replace(/\s+/g, '-').toLowerCase()}>
                      {item}
                    </label>
                  </div>
                ))}
                <div className="alumnifeedback-checkbox-item">
                  <input
                    type="checkbox"
                    id="other-academic"
                    checked={formData.academic.includes('Other')}
                    onChange={() => handleCheckboxChange('academic', 'Other')}
                  />
                  <label htmlFor="other-academic">Other</label>
                </div>

                {formData.academic.includes('Other') && (
                  <div className="alumnifeedback-form-field">
                    <input
                      type="text"
                      name="otherAcademic"
                      value={formData.otherAcademic}
                      onChange={handleChange}
                      className="alumnifeedback-input-field"
                      placeholder="Please specify other academic involvement"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Administrative */}
            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-subsection-title">
                ❖ Administrative
              </h3>
              <div className="alumnifeedback-checkbox-group">
                {[
                  'Assist in the formation of plans, programs, projects of the alumni',
                  'Assist in appraising institutional objectives in relation to community services',
                ].map((item) => (
                  <div key={item} className="alumnifeedback-checkbox-item">
                    <input
                      type="checkbox"
                      id={item.replace(/\s+/g, '-').toLowerCase()}
                      checked={formData.administrative.includes(item)}
                      onChange={() =>
                        handleCheckboxChange('administrative', item)
                      }
                    />
                    <label htmlFor={item.replace(/\s+/g, '-').toLowerCase()}>
                      {item}
                    </label>
                  </div>
                ))}
                <div className="alumnifeedback-checkbox-item">
                  <input
                    type="checkbox"
                    id="other-administrative"
                    checked={formData.administrative.includes('Other')}
                    onChange={() =>
                      handleCheckboxChange('administrative', 'Other')
                    }
                  />
                  <label htmlFor="other-administrative">Other</label>
                </div>

                {formData.administrative.includes('Other') && (
                  <div className="alumnifeedback-form-field">
                    <input
                      type="text"
                      name="otherAdministrative"
                      value={formData.otherAdministrative}
                      onChange={handleChange}
                      className="alumnifeedback-input-field"
                      placeholder="Please specify other administrative involvement"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Finance */}
            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-subsection-title">
                ❖ Finance/Development
              </h3>
              <div className="alumnifeedback-checkbox-group">
                {[
                  'Assist in the fund raising activities in the university',
                  'Assist in generating resources for the realization of the objectives of the alumni affairs',
                  'Assist in the development programs of the university',
                  'Outreach Program',
                  'Environmental Concerns',
                ].map((item) => (
                  <div key={item} className="alumnifeedback-checkbox-item">
                    <input
                      type="checkbox"
                      id={item.replace(/\s+/g, '-').toLowerCase()}
                      checked={formData.finance.includes(item)}
                      onChange={() => handleCheckboxChange('finance', item)}
                    />
                    <label htmlFor={item.replace(/\s+/g, '-').toLowerCase()}>
                      {item}
                    </label>
                  </div>
                ))}
                <div className="alumnifeedback-checkbox-item">
                  <input
                    type="checkbox"
                    id="other-finance"
                    checked={formData.finance.includes('Other')}
                    onChange={() => handleCheckboxChange('finance', 'Other')}
                  />
                  <label htmlFor="other-finance">Other</label>
                </div>

                {formData.finance.includes('Other') && (
                  <div className="alumnifeedback-form-field">
                    <input
                      type="text"
                      name="otherFinance"
                      value={formData.otherFinance}
                      onChange={handleChange}
                      className="alumnifeedback-input-field"
                      placeholder="Please specify other finance/development involvement"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Textareas */}
            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-section-title">
                What important things have you learned at SMU that helped you
                improve yourself in your field and in the community you work
                with?
                <span className="alumnifeedback-required">*</span>
              </h3>
              <div className="alumnifeedback-form-field full-width">
                <textarea
                  name="importantThings"
                  value={formData.importantThings}
                  onChange={handleChange}
                  className="alumnifeedback-input-field alumnifeedback-textarea"
                  placeholder="Write your response here"
                  rows="4"
                  required
                />
              </div>
            </div>

            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-section-title">
                What comments/suggestions can you give to improve the
                university's system?
                <span className="alumnifeedback-required">*</span>
              </h3>
              <div className="alumnifeedback-form-field full-width">
                <textarea
                  name="suggestions"
                  value={formData.suggestions}
                  onChange={handleChange}
                  className="alumnifeedback-input-field alumnifeedback-textarea"
                  placeholder="Curricular Programs, Services, Outreach Programs, etc."
                  rows="4"
                  required
                />
              </div>
            </div>

            <div className="alumnifeedback-section">
              <h3 className="alumnifeedback-section-title">
                List down names and addresses of alumni you know{' '}
                <span className="alumnifeedback-required">*</span>
              </h3>
              <div className="alumnifeedback-form-field full-width">
                <textarea
                  name="alumniList"
                  value={formData.alumniList}
                  onChange={handleChange}
                  className="alumnifeedback-input-field alumnifeedback-textarea"
                  placeholder="Alumni Names and Addresses"
                  rows="3"
                  required
                />
              </div>
            </div>

            {statusMessage && (
              <div className={`alumnifeedback-status-message ${statusType}`}>
                {statusType === 'success' ? '✅' : '❌'} {statusMessage}
              </div>
            )}

            <div className="alumnifeedback-buttons-container">
              <button type="submit" className="alumnifeedback-submit-button">
                Submit Feedback
              </button>
            </div>

            <p className="alumnifeedback-form-footer">
              Return to dashboard?{' '}
              <Link to="/AlumniDashboard" className="alumnifeedback-link">
                Dashboard
              </Link>
            </p>
          </form>
        </div>
      </div>

  );
};

export default AlumniFeedback;
